import { toast as _toast } from 'react-toastify';

export const toast = (message, toastId) => {
    if (!_toast.isActive(toastId)) {
        _toast(message, {
            position: _toast.POSITION.TOP_RIGHT,
            className: 'toastify',
            toastId: toastId || message
        });
    }
}